/**
 * FANPLAZA Search Overlay — Predictive Search
 */
(function () {
  'use strict';

  var overlay = document.getElementById('fp-search-overlay');
  var input = document.getElementById('fp-search-input');
  var clearBtn = document.getElementById('fp-search-clear');
  var suggestions = document.getElementById('fp-search-suggestions');
  var resultsContainer = document.getElementById('fp-search-results');
  var openBtns = document.querySelectorAll('[data-search-open]');
  var closeBtns = document.querySelectorAll('[data-search-close]');
  var popularBtns = document.querySelectorAll('[data-search-term]');

  if (!overlay || !input) return;

  var debounceTimer = null;

  function updateOverlayPosition() {
    var headerSection = document.querySelector('.fp-header-section');
    if (headerSection) {
      var h = headerSection.getBoundingClientRect().bottom;
      overlay.style.top = h + 'px';
    }
  }

  function openSearch() {
    updateOverlayPosition();
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      input.focus();
    });
  }

  function closeSearch() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    input.value = '';
    clearBtn.style.display = 'none';
    resultsContainer.style.display = 'none';
    resultsContainer.innerHTML = '';
    suggestions.style.display = '';
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });

  // Escape to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
      closeSearch();
    }
  });

  // Clear button
  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.style.display = 'none';
    resultsContainer.style.display = 'none';
    resultsContainer.innerHTML = '';
    suggestions.style.display = '';
    input.focus();
  });

  // Popular search terms
  popularBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var term = btn.dataset.searchTerm;
      input.value = term;
      clearBtn.style.display = '';
      performSearch(term);
    });
  });

  // Input handler with debounce
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearBtn.style.display = q.length > 0 ? '' : 'none';

    if (debounceTimer) clearTimeout(debounceTimer);

    if (q.length < 2) {
      resultsContainer.style.display = 'none';
      resultsContainer.innerHTML = '';
      suggestions.style.display = '';
      return;
    }

    debounceTimer = setTimeout(function () {
      performSearch(q);
    }, 300);
  });

  // Enter to go to full search results
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = input.value.trim();
      if (q.length > 0) {
        window.location.href = '/search?q=' + encodeURIComponent(q);
      }
    }
  });

  function performSearch(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
        renderResults(products, query);
      })
      .catch(function () {
        resultsContainer.innerHTML = '<p class="fp-search-overlay__no-results">Something went wrong. Please try again.</p>';
        resultsContainer.style.display = '';
        suggestions.style.display = 'none';
      });
  }

  function renderResults(products, query) {
    suggestions.style.display = 'none';

    if (products.length === 0) {
      resultsContainer.innerHTML = '<p class="fp-search-overlay__no-results">No results for \u201c' + escapeHtml(query) + '\u201d</p>';
      resultsContainer.style.display = '';
      return;
    }

    var html = '';
    products.forEach(function (product) {
      var imgSrc = product.image
        ? product.image.replace(/(\.[^.]+)$/, '_400x$1')
        : '';
      var price = product.price;

      html += '<a href="' + product.url + '" class="fp-search-overlay__result-card">';
      if (imgSrc) {
        html += '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" class="fp-search-overlay__result-image" loading="lazy">';
      }
      html += '<div class="fp-search-overlay__result-info">';
      html += '<p class="fp-search-overlay__result-title">' + escapeHtml(product.title) + '</p>';
      html += '<p class="fp-search-overlay__result-price">' + price + '</p>';
      html += '</div></a>';
    });

    resultsContainer.innerHTML = html;
    resultsContainer.style.display = '';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
})();
